import React from 'react';
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHead,
} from '@/components/ui/table';
import UserTableRow from './UserTableRow';
import { UserManagementTableProps } from '../types';

const UserManagementTable: React.FC<UserManagementTableProps> = ({
  users,
  onEditRoles,
  onEditProfile,
  onChangePassword,
  onViewPassword,
  onNotifyCredentials,
  loadingActions,
  canViewPasswords,
  canManageRoles,
}) => {
  if (!users || users.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        No se encontraron usuarios
      </div>
    );
  }

  return (
    <Table className="table-responsive">
      <TableHeader>
        <TableRow>
          <TableHead>Email</TableHead>
          <TableHead>Nombre</TableHead>
          <TableHead>DNI</TableHead>
          <TableHead>Teléfono</TableHead>
          <TableHead>Roles</TableHead>
          <TableHead>Acciones</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {users.map(user => (
          <UserTableRow
            key={`user-${user.id}`}
            user={user}
            onEditRoles={onEditRoles}
            onEditProfile={onEditProfile}
            onChangePassword={onChangePassword}
            onViewPassword={onViewPassword}
            onNotifyCredentials={onNotifyCredentials}
            loadingActions={loadingActions}
            canViewPasswords={canViewPasswords}
            canManageRoles={canManageRoles}
          />
        ))}
      </TableBody>
    </Table>
  );
};

export default UserManagementTable;
